const BASE_PALETTE = [
  "#080606",
  "#0a0807",
  "#100909",
  "#120b08",
  "#130f0a",
  "#15120d",
];

const ACCENT_PALETTE_WEIGHTED = [
  { color: [138, 14, 14], weight: 4.2 },
  { color: [168, 11, 11], weight: 4.8 },
  { color: [184, 28, 20], weight: 2.4 },
  { color: [199, 160, 58], weight: 4.4 },
  { color: [179, 132, 36], weight: 2.8 },
  { color: [120, 46, 18], weight: 1.4 },
  { color: [154, 109, 23], weight: 0.9 },
  { color: [42, 95, 175], weight: 0.6 },
];

const rand = (min, max) => Math.random() * (max - min) + min;
const pick = (list) => list[Math.floor(Math.random() * list.length)];
const rgba = ([r, g, b], alpha) => `rgba(${r}, ${g}, ${b}, ${alpha})`;

function pickWeighted(list) {
  const total = list.reduce((acc, item) => acc + item.weight, 0);
  let cursor = rand(0, total);

  for (const item of list) {
    cursor -= item.weight;
    if (cursor <= 0) {
      return item.color;
    }
  }

  return list[list.length - 1].color;
}

export function generateDynamicBackgroundTheme() {
  const c1 = pickWeighted(ACCENT_PALETTE_WEIGHTED);
  const c2 = pickWeighted(ACCENT_PALETTE_WEIGHTED);
  const c3 = pickWeighted(ACCENT_PALETTE_WEIGHTED);

  return {
    glowTop: rgba(c1, rand(0.24, 0.34)),
    glowBottom: rgba(c2, rand(0.15, 0.24)),
    glowMid: rgba(c3, rand(0.1, 0.18)),
    glowTopPos: `${Math.round(rand(66, 88))}% ${Math.round(rand(6, 22))}%`,
    glowBottomPos: `${Math.round(rand(3, 18))}% ${Math.round(rand(74, 92))}%`,
    glowMidPos: `${Math.round(rand(34, 62))}% ${Math.round(rand(30, 64))}%`,
    glowTopSize: `${Math.round(rand(30, 44))}%`,
    glowBottomSize: `${Math.round(rand(28, 42))}%`,
    glowMidSize: `${Math.round(rand(26, 40))}%`,
    baseStart: pick(BASE_PALETTE),
    baseEnd: pick(BASE_PALETTE),
    angle: `${Math.round(rand(122, 158))}deg`,
  };
}
